<div class="container-no-overflow" [ngClass]="{ 'container-filter': dialogMode }">
    <div class="row">
        <div class="col-md-12">
            <h4>{{ title }}</h4>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-success">
                <div class="card-header-buscador">
                    <i class="fa fa-align-justify"></i> {{ title }}
                </div>

                <div class="card-body-grid" *ngIf="result">

                    <p-table #tableSearch autoLayout="true" [value]="result" [lazy]="false"
                             rowExpandMode="single" dataKey="Id"
                             [lazyLoadOnInit]="false" [rowHover]="true"
                             [paginator]="false" [columns]="cols"
                             [rows]="result?.length" sortOrder="0"
                             [totalRecords]="result?.length" [loading]="loading"
                             [ngClass]="displayGridHidden(result)"
                             styleClass="table table-responsive-sm  table-striped table-sm">

                        <ng-template pTemplate="header" let-columns let-expanded="expanded" let-rowIndex="rowIndex">
                            <tr>
                                <th scope="col" *ngFor="let col of columns" [ngClass]="{ 'th-xs': col.reduce }" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                    {{ col.header }}
                                    <p-sortIcon *ngIf="col.field !== 'Link' && col.field!=='ExpandLink'" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                            <tr>
                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                    <ng-container *ngIf="col.field==='ExpandLink' && esDesautorizado(rowData)">
                                        <div class="btn-group">
                                            <div style="text-align: center;">
                                                <span>
                                                    <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData"
                                                        [title]="expanded ? 'Ocultar Campañas' : 'Mostrar Campañas'" 
                                                        [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                                    </a>
                                                </span>
                                            </div>
                                            <span class="fa fa-ban" title="Desautorizado"></span>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="col.field!=='Link' && col.field!=='ExpandLink'">
                                        <span *ngIf="col.field === 'SuperficieVariedad' || col.field === 'ProduccionEstimada'">
                                            {{ rowData[col.field] | number:'1.2-5':'es-ES' }}
                                        </span>
                                        <span *ngIf="col.field !== 'SuperficieVariedad' && col.field !== 'ProduccionEstimada'">
                                            {{ rowData[col.field] }}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="col.field==='Link' && !dialogMode" class="btn-group">
                                        <button (click)="onView(rowData)" type="button" class="btn btn-sm btn-info" title="Consultar">
                                            <span class="fa fa-eye"></span>
                                        </button>
                                        <!-- @author: scalero1 - Dejar como referencia éste código comentado. -->
                                        <!--
                                        <button (click)="onEdit(rowData)" type="button" class="btn btn-sm" title="Editar">
                                            <span class="fa fa-edit"></span>
                                        </button>
                                        -->

                                        <ng-container *ngIf="showBajaBtn(rowData)">
                                            <button (click)="onDarDeBaja(rowData)" type="button" class="btn btn-sm btn-warning" title="Dar de Baja">
                                                <span class="fa fa-archive"></span>
                                            </button>
                                        </ng-container>
                                        <div *ngIf="habilitarEliminar" class="btn-group">
                                            <button (click)="onDelete(rowData)" type="button" class="btn btn-sm btn-warning" title="Eliminar cultivo">
                                                <span class="fa fa-remove"></span>
                                            </button>
                                        </div>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Fecha</th>
                                <th colspan="4">Desautorizado en campaña</th>                                    
                            </tr>
                            <tr *ngFor="let campania of rowData['CampaniasDesautorizado']">
                                <td></td>
                                <td>
                                    <button *ngIf="showAuthorizeBtn(rowData)" (click)="onAuthorize(rowData, campania.Id)" type="button" class="btn btn-sm btn-warning" title="Autorizar Cultivo en Campaña">
                                        <span class="fa fa-thumbs-o-up"></span>
                                    </button>
                                </td>
                                <td>{{ campania?.Fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                                <td colspan="4">{{ campania?.Descripcion }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div *ngIf="tableSearch?.totalRecords === 0" class="empty-grid">No se ha encontrado ningún registro</div>
                    <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                    <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                </div>
            </div>
        </div>
    </div>
</div>
